/* eslint-disable @typescript-eslint/ban-ts-comment */
import { Schema } from 'prosemirror-model';

const spanDOM = ['span', 0];

const nodes = {
  text: {
    group: "inline",
  },
  paragraph: {
    content: 'inline*',
    group: 'block',
    parseDOM: [{ tag: 'span' }],
    toDOM(node) {
      return spanDOM;
    },
  },
  doc: { content: 'block+' },
};

const marks = {
  annotation: {
    attrs: {
      uuid: { default: null },
    },
    inclusive: false,
    parseDOM: [
      {
        tag: 'mark[uuid]',
        getAttrs(dom) {
          return {
            uuid: dom.getAttribute('uuid'),
          };
        },
      },
    ],
    toDOM(node) {
      const { uuid } = node.attrs;
      return ['mark', { uuid }, 0];
    },
    clearable: false,
  },

  deleted: {
    toDOM() {
      return ['span', { class: 'removed' }];
    },
  },
};

// @ts-ignore
const schema = new Schema({ nodes, marks });
// @ts-ignore
schema.nullDoc = {
  state: {
    doc: { type: 'doc' },
    selection: { type: 'text', anchor: 0, head: 0 },
  },
  trackState: null,
};

export default schema;



// WEBPACK FOOTER //
// ./app/javascript/client/editor-core/headlineSchema.js